import CardStory from './CardStory';
import DialogSuggestion from './DialogSuggestion';
import ImageContent from './ImageContent';
import Loading from './Loading';
import Location from './Location';
import Logo from './Logo';
import Navigation from './Navigation';
import NextPage from './NextPage';
import Uri from './Uri';
import ElTiempoHeader from './Clients';
import EroskiHeader from './EroskiHeader';

export {
  CardStory,
  DialogSuggestion,
  ImageContent,
  Loading,
  Location,
  Logo,
  Navigation,
  NextPage,
  Uri,
  ElTiempoHeader,
  EroskiHeader
};
